export const CLEAR_POINT_DETAILS = 'CLEAR_POINT_DETAILS';
export const POPULATE_POINT_PRIMARY_DETAILS = 'POPULATE_POINT_DETAILS';
export const POPULATE_POINT_EXTENDED_DETAILS = 'POPULATE_POINT_EXTENDED_DETAILS';
export const SELECT_DATA_SET = 'SELECT_DATA_SET';
export const CLEAR_GRAPH_DATA = 'CLEAR_GRAPH_DATA';
export const REBUILD_GRAPH_DATA = 'REBUILD_GRAPH_DATA';
export const TOGGLE_GRAPH_SERIES = 'TOGGLE_GRAPH_SERIES';
export const TOGGLE_BOUNDARY = 'TOGGLE_BOUNDARY';
export const ACTIVATE_BOUNDARY = 'ACTIVATE_BOUNDARY';
export const POPULATE_BOUNDARY_DATA = 'POPULATE_BOUNDARY_DATA';
export const POPULATE_INDICATOR_DETAILS = 'POPULATE_INDICATOR_DETAILS';
export const POPULATE_BUSHFIRE_DETAILS = 'POPULATE_BUSHFIRE_DETAILS';
export const POPULATE_BURN_DETAILS = 'POPULATE_BURN_DETAILS';
export const POPULATE_BURN_POLYGONS = 'POPULATE_BURN_POLYGONS';
export const POPULATE_BURNT_AREA_POLYGONS = 'POPULATE_BURNT_AREA_POLYGONS';
export const POPULATE_BURN_PRESCRIPTIONS = 'POPULATE_BURN_PRESCRIPTIONS';
export const CLEAR_BURN_PRESCRIPTION_WEATHER = 'CLEAR_BURN_PRESCRIPTION_WEATHER';
export const CLEAR_AND_REFRESH_BURN_PRESCRIPTION_WEATHER = 'CLEAR_AND_REFRESH_BURN_PRESCRIPTION_WEATHER';
export const REFRESH_BURN_PRESCRIPTION_WEATHER = 'REFRESH_BURN_PRESCRIPTION_WEATHER';
export const POPULATE_BURN_PRESCRIPTION_WEATHER = 'POPULATE_BURN_PRESCRIPTION_WEATHER';
export const REFRESH_BURN_PRESCRIPTIONS_COMPLETE = 'REFRESH_BURN_PRESCRIPTIONS_COMPLETE';
export const UPDATE_POINT_DETAILS = 'UPDATE_POINT_DETAILS';
export const SWITCH_ACTIVE_INDICATOR = 'SWITCH_ACTIVE_INDICATOR';
export const UPDATE_INDICATOR_TIMES = 'UPDATE_INDICATOR_TIMES';
export const SET_MAP_CENTER = 'SET_MAP_CENTER';
export const SET_MAP_BOUNDS_AND_ZOOM = 'SET_MAP_BOUNDS_AND_ZOOM';
export const SET_MAP_MIN_ZOOM = 'SET_MAP_MIN_ZOOM';
export const SET_MAP_MIN_CONTROLS = 'SET_MAP_MIN_CONTROLS';
export const MAP_RECENTRED = 'MAP_RECENTRED';
export const OPEN_MESSAGE = 'OPEN_MESSAGE';
export const CLOSE_MESSAGE = 'CLOSE_MESSAGE';
export const TOGGLE_OVERLAY = 'TOGGLE_OVERLAY';
export const ACTIVATE_OVERLAY = 'ACTIVATE_OVERLAY';
export const CLOSE_OVERLAYS = 'CLOSE_OVERLAYS';
export const TOGGLE_INCIDENT_TYPE = 'TOGGLE_INCIDENT_TYPE';
export const START_PLAYING = 'START_PLAYING';
export const SET_PLAY_SPEED = 'SET_PLAY_SPEED';
export const STOP_PLAYING = 'STOP_PLAYING';
export const TICK_PLAYING = 'TICK_PLAYING';
export const SET_TIMER = 'SET_TIMER';
export const SET_APP_MODE = 'SET_APP_MODE';
export const SET_ACTIVE_POINT = 'SET_ACTIVE_POINT';
export const SET_CURSOR_POINT = 'SET_CURSOR_POINT';
export const SET_ACTIVE_INCIDENT_FEATURE = 'SET_ACTIVE_INCIDENT_FEATURE';
export const SET_ACTIVE_INCIDENT = 'SET_ACTIVE_INCIDENT';
export const ACTIVATE_INCIDENT_WHEN_LOADED = 'ACTIVATE_INCIDENT_WHEN_LOADED';
export const SET_ACTIVE_PRESCRIPTION = 'SET_ACTIVE_PRESCRIPTION';
export const SET_POINT_FUEL_TYPE = 'SET_POINT_FUEL_TYPE';
export const SET_POINT_TOTAL_FUEL_LOAD = 'SET_POINT_TOTAL_FUEL_LOAD';
export const SET_URL = 'SET_URL';
export const SET_URL_HASH = 'SET_URL_HASH';
export const SET_ACTIVE_TIME = 'SET_ACTIVE_TIME';
export const SET_DISPLAY_TIME = 'SET_DISPLAY_TIME';
export const SET_DISPLAY_TIME_FOR_ACTIVE_INDICATOR = 'SET_DISPLAY_TIME_FOR_ACTIVE_INDICATOR';
export const POPULATE_VALID_TIMES = 'POPULATE_VALID_TIMES';
export const CLOSE_POPUP = 'CLOSE_POPUP';
export const OPEN_GRAPHS_VIEW = 'OPEN_GRAPHS_VIEW';
export const CLOSE_GRAPHS_VIEW = 'CLOSE_GRAPHS_VIEW';
export const SET_POP_OUT = 'SET_POP_OUT';
export const TOGGLE_POPUP_EXPANDED = 'TOGGLE_POPUP_EXPANDED';
export const TOGGLE_GRAPHS_EXPANDED = 'TOGGLE_GRAPHS_EXPANDED';
export const SET_GRAPHS_EXPANDED = 'SET_GRAPHS_EXPANDED';
export const TOGGLE_GRAPHS_HISTORY = 'TOGGLE_GRAPHS_HISTORY';
export const TOGGLE_GRAPHS_DAYS = 'TOGGLE_GRAPHS_DAYS';
export const TOGGLE_SHOW_ALL_CALC_COLUMNS = 'TOGGLE_SHOW_ALL_CALC_COLUMNS';
export const SET_SHOW_WEATHER = 'SET_SHOW_WEATHER';
export const SET_TABLE_BACKGROUND = 'SET_TABLE_BACKGROUND';
export const SET_TABLE_DIRECTIONS = 'SET_TABLE_DIRECTIONS';
export const EJECT_GRAPHS_VIEW = 'EJECT_GRAPHS_VIEW';
export const PRINT_GRAPHS_VIEW = 'PRINT_GRAPHS_VIEW';
export const TOGGLE_POINT_DATA_DISPLAY = 'TOGGLE_POINT_DATA_DISPLAY';
export const DROPDOWN_INDICATORS_OPEN = 'DROPDOWN_INDICATORS_OPEN';
export const DROPDOWN_BOUNDARIES_OPEN = 'DROPDOWN_BOUNDARIES_OPEN';
export const DROPDOWN_LEGEND_OPEN = 'DROPDOWN_LEGEND_OPEN';
export const GRAPH_DATA_LOADED = 'GRAPH_DATA_LOADED';
export const START_LOCATION_SEARCH = 'START_LOCATION_SEARCH';
export const STOP_LOCATION_SEARCH = 'STOP_LOCATION_SEARCH';
export const CLEAR_WIND_DATA = 'CLEAR_WIND_DATA';
export const POPULATE_MAGNITUDE_DATA = 'POPULATE_MAGNITUDE_DATA';
export const POPULATE_DIRECTION_DATA = 'POPULATE_DIRECTION_DATA';
export const SET_VELOCITY_DATA = 'SET_VELOCITY_DATA';
export const SET_BARB_DATA = 'SET_BARB_DATA';
export const POPULATE_INDICATOR_GRAPH_POINT = 'POPULATE_INDICATOR_GRAPH_POINT';
export const GRAPH_PROGRESS_TICK = 'GRAPH_PROGRESS_TICK';
export const POPULATE_AWS_DATA = 'POPULATE_AWS_DATA';
export const POPULATE_AWS_GRAPH_DATA = 'POPULATE_AWS_GRAPH_DATA';
export const POPULATE_AQFX_DATA = 'POPULATE_AQFX_DATA';
export const TOGGLE_AQFX_PANEL = 'TOGGLE_AQFX_PANEL';
export const SELECT_AQFX_NUMBER = 'SELECT_AQFX_NUMBER';
export const FIND_NEAREST_AWS = 'FIND_NEAREST_AWS';
export const POPULATE_FMS_DATA = 'POPULATE_FMS_DATA';
export const POPULATE_FMS_GRAPH_DATA = 'POPULATE_FMS_GRAPH_DATA';
export const FIND_NEAREST_FMS = 'FIND_NEAREST_FMS';
export const TOGGLE_MENU = 'TOGGLE_MENU';
export const SET_CENTRE_MESSAGE = 'SET_CENTRE_MESSAGE';
export const SET_LOADING_MESSAGE = 'SET_LOADING_MESSAGE';
export const ADD_LOADED_TIMES = 'ADD_LOADED_TIMES';
export const CLEAR_LOADED_TIMES = 'CLEAR_LOADED_TIMES';
export const INCREMENT_LOADING_INDEX = 'INCREMENT_LOADING_INDEX';
export const RESET_LOADING_INDEX = 'RESET_LOADING_INDEX';
export const EXTRACT_INDICATOR_OVERLAY_INTERVALS = 'EXTRACT_INDICATOR_OVERLAY_INTERVALS';
export const RESET_INDICATOR_OVERLAYS = 'RESET_INDICATOR_OVERLAYS';
export const SET_INDICATOR_OVERLAY_INTERVALS = 'SET_INDICATOR_OVERLAY_INTERVALS';
export const CLEAR_INDICATOR_OVERLAY_INTERVALS = 'CLEAR_INDICATOR_OVERLAY_INTERVALS';
export const START_TIMELINE_DRAG = 'START_TIMELINE_DRAG';
export const STOP_TIMELINE_DRAG = 'STOP_TIMELINE_DRAG';
export const TOGGLE_TIMELINE_HISTORY = 'TOGGLE_TIMELINE_HISTORY';
export const SET_TIMELINE_NOW = 'SET_TIMELINE_NOW';
export const RESET_MAP = 'RESET_MAP';
export const RESET_LAYERS = 'RESET_LAYERS';
export const TOGGLE_DISCLAIMER = 'TOGGLE_DISCLAIMER';
export const WIND_DATA_LOAD_STARTING = 'WIND_DATA_LOAD_STARTING';
export const WIND_DATA_LOAD_COMPLETE = 'WIND_DATA_LOAD_COMPLETE';
export const SET_KEYCLOAK = 'SET_KEYCLOAK';
export const SET_KEYCLOAK_DISABLED = 'SET_KEYCLOAK_DISABLED';
export const SET_BEHAVIOUR_VARIABLES = 'SET_BEHAVIOUR_VARIABLES';
export const CALCULATE_MCARTHUR_MK5 = 'CALCULATE_MCARTHUR_MK5';
export const CALCULATE_VESTA = 'CALCULATE_VESTA';
export const CALCULATE_VESTA_MK2 = 'CALCULATE_VESTA_MK2';
export const CALCULATE_LEAFLET_80 = 'CALCULATE_LEAFLET_80';
export const CALCULATE_PRESCRIPTIONS = 'CALCULATE_PRESCRIPTIONS';
export const CALCULATE_GRASS = 'CALCULATE_GRASS';
export const CALCULATE_MALLEE_HEATH = 'CALCULATE_MALLEE_HEATH';
export const POPULATE_MANUAL_WEATHER_DATA = 'POPULATE_MANUAL_WEATHER_DATA';
export const FIND_NEAREST_MANUAL_WEATHER = 'FIND_NEAREST_MANUAL_WEATHER';
export const SET_MANUAL_WEATHER_DATA = 'SET_MANUAL_WEATHER_DATA';
export const SET_MANUAL_WEATHER_DATA_SINGLE_VARIABLE = 'SET_MANUAL_WEATHER_DATA_SINGLE_VARIABLE';
export const RESET_MANUAL_WEATHER_DATA = 'RESET_MANUAL_WEATHER_DATA';
export const RESET_MANUAL_WEATHER_DATA_SINGLE_VARIABLE = 'RESET_MANUAL_WEATHER_DATA_SINGLE_VARIABLE';
export const RESET_ALL_MANUAL_WEATHER_DATA = 'RESET_ALL_MANUAL_WEATHER_DATA';
export const EXPORT_DATA = 'EXPORT_DATA';
export const STORAGE_EVENT = 'STORAGE_EVENT';
export const SET_QS_STATION_ID = 'SET_QS_STATION_ID';



// WEBPACK FOOTER //
// ./src/actions/actionTypes.js